import { render, staticRenderFns } from "./view-item-relation-to-many.vue?vue&type=template&id=3fb3d164&"
import script from "./view-item-relation-to-many.vue?vue&type=script&lang=js&"
export * from "./view-item-relation-to-many.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports